import React from 'react';
import Countries from './Countries';
import Navbar from './Navbar';

const Home = () => {
  return (
    <div>
      <Navbar />
      <Countries />
    </div>
  );
};

export default Home;
